import { ContainerModule } from 'inversify';
import Dispatcher from '@framework/analytics-tracker/Sender/senders/SocketDispatcher';
import SocketDITypes from '@finsight/socket-client/DITypes';
import type { ISocketDispatcher } from '@finsight/socket-client';

export const analyticsModule: ContainerModule = new ContainerModule(({ bind }) => {
  bind(Dispatcher).toDynamicValue(({ get }) => get<ISocketDispatcher>(SocketDITypes.SocketDispatcher)).inSingletonScope();
});
